/**
 * Slugs reservados por el sistema para evitar colisiones con rutas oficiales de Calenddy
 */
export const RESERVED_SLUGS = [
  'dashboard',
  'api',
  'precios',
  'funciones',
  'ingresar',
  'registro',
  'login',
  'register',
  'mis-turnos',
  'terminos',
  'privacidad',
  'politicas',
  'checkout',
  'pago',
  'favicon.ico',
  '_next',
  'manifest.json',
  'robots.txt',
  'sitemap.xml',
  'icon.png',
  'apple-icon.png'
];

export function isReservedSlug(slug: string): boolean {
  if (!slug) return false;
  return RESERVED_SLUGS.includes(slug.toLowerCase().trim());
}
